import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Footer from "./Component/Footer";
import Appintroduction from "../src/pages/Home/Appintroduction";
import Navbar from "./Component/Navbar";
import Commiteemember from "../src/pages/Home/Commiteemember";
import Privacypolicy from "./pages/Home/Privacypolicy";
import About from "../src/pages/AboutUs/About";
import Firstconvo from "./pages/Gallery/Firstconvo";
import Secondconvo from "./pages/Gallery/Secodndconvo";
import Fourtrhconvo from "./pages/Gallery/Fourtrhconvo";
import Fifthconvo from "./pages/Gallery/Fifthconvo";
import Sixthconvo from "./pages/Gallery/Sixthconvo";
import Seventhconvo from "./pages/Gallery/Seventhconvo";
import Eightthconvo from "./pages/Gallery/Eighthconvo";
import Hitechchhoo from "./pages/Socialmedia/Hitechchhoo";
import Newsletters from "./pages/Socialmedia/Newsletters";
import Manavseva from "./pages/Socialmedia/Manavseva";
import Mochitimes from "./pages/Socialmedia/Mochitimes";
import Worldwidemandals from "./pages/Socialmedia/Worldwidemandals";
import Gujaraticalender from "./pages/Socialmedia/Gujaraticalender";
import Commiteememberpage from "../src/pages/ContactUs/Commiteemembers";
import Contactus from "./pages/ContactUs/Contactus";
import Home from "./pages/Home/Home";
import Sponsormodel from "./Component/Sponsormodel";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/Appintroduction" element={<Appintroduction />} />
        <Route exact path="/Commiteemember" element={<Commiteemember />} />
        <Route exact path="/Privacypolicy" element={<Privacypolicy />} />
        <Route exact path="/Aboutus" element={<About />} />
        <Route exact path="/Firstconvo" element={<Firstconvo />} />
        <Route exact path="/Secondconvo" element={<Secondconvo />} />
        <Route exact path="/Fourthconvo" element={<Fourtrhconvo />} />
        <Route exact path="/Fifthconvo" element={<Fifthconvo />} />
        <Route exact path="/Sixthconvo" element={<Sixthconvo />} />
        <Route exact path="/Seventhconvo" element={<Seventhconvo />} />
        <Route exact path="/Eightthconvo" element={<Eightthconvo />} />
        <Route exact path="/Hitechhoo" element={<Hitechchhoo />} />
        <Route exact path="/Newsletters" element={<Newsletters />} />
        <Route exact path="/Manavseva" element={<Manavseva />} />
        <Route exact path="/Mochitimes" element={<Mochitimes />} />
        <Route exact path="/Worldwidemandals" element={<Worldwidemandals />} />
        <Route exact path="/Gujaraticalander" element={<Gujaraticalender />} />
        <Route
          exact
          path="/Commiteememberpage"
          element={<Commiteememberpage />}
        />
        <Route exact path="/Contactus" element={<Contactus />} />
        <Route exact path="/Sponsormodel" element={<Sponsormodel />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
